// extracted by mini-css-extract-plugin
module.exports = {"link":"BoatsCard_link__1yVdG","pricePerDay":"BoatsCard_pricePerDay__1eF6F"};